import { ApolloClient } from "@apollo/client";
import { CHANGE_USER_UI_SETTINGS, GET_USER_UI_SETTINGS } from "../graphql/users.graphql";
import { TableUISettings, UISettings } from "../shared/Types";

const LOCAL_STORAGE_KEY = "uiSettings";

export class UserUISettingsService {
  constructor(
    private client: ApolloClient<any>,
    private useLocalStorage: boolean = false // <-- add this prop
  ) {}

  // Change user settings (partial update)
  async changeSettings(newSettings: UISettings): Promise<UISettings | undefined> {
    // if (!newSettings.tables) {
    //   newSettings.tables = {};
    // }
    const uiSettings = JSON.stringify(newSettings);

    if (this.useLocalStorage) {
      try {
        localStorage.setItem(LOCAL_STORAGE_KEY, uiSettings);
        return newSettings;
      } catch (e) {
        console.error("Failed to save uiSettings to localStorage:", e);
        return undefined;
      }
    }

    // GraphQL logic
    const result = await this.client.mutate({
      mutation: CHANGE_USER_UI_SETTINGS,
      variables: { uiSettings },
    });
    const raw = result.data?.changeUserSettings?.uiSettings;
    try {
      return raw ? (JSON.parse(raw) as UISettings) : undefined;
    } catch (e) {
      console.error("Failed to parse uiSettings from mutation:", raw, e);
      return undefined;
    }
  }

  // Get current user settings
  async getSettings(): Promise<UISettings | undefined> {
    if (this.useLocalStorage) {
      try {
        const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
        return raw ? (JSON.parse(raw) as UISettings) : undefined;
      } catch (e) {
        console.error("Failed to parse uiSettings from localStorage:", e);
        return undefined;
      }
    }

    // GraphQL logic
    const result = await this.client.query({
      query: GET_USER_UI_SETTINGS,
      fetchPolicy: "network-only",
    });
    const raw = result.data?.user?.me?.settings?.uiSettings;
    try {
      return raw ? (JSON.parse(raw) as UISettings) : undefined;
    } catch (e) {
      console.error("Failed to parse uiSettings from query:", raw, e);
      return undefined;
    }
  }

  setTableSettings(
    uiSettings: UISettings,
    tableKey: string,
    visibility: Record<string, boolean> = {},
    order: string[] = [],
    pageSize: number
  ): UISettings {
    return {
      ...uiSettings,
      // tables: {
      //   ...uiSettings.tables,
      //   [tableKey]: {
      //     columnVisibility: visibility,
      //     columnOrder: order,
      //     pageSize,
      //   },
      // },
      [tableKey + "ColumnVisibility"]: visibility,
      [tableKey + "ColumnOrder"]: order,
      [tableKey + "PageSize"]: pageSize,
    };
  }

  getTableSettings(
    uiSettings: UISettings,
    tableKey: string
  ): TableUISettings | undefined {
    const columnVisibility = uiSettings[tableKey + "ColumnVisibility"];
    const columnOrder = uiSettings[tableKey + "ColumnOrder"];
    let pageSize = uiSettings[tableKey + "PageSize"];

    // Convert pageSize to integer if it's a string
    if (typeof pageSize === "string") {
      const parsed = parseInt(pageSize, 10);
      pageSize = isNaN(parsed) ? 10 : parsed;
    }

    if (columnVisibility || columnOrder || pageSize) {
      return {
        columnVisibility: columnVisibility || {},
        columnOrder: columnOrder || [],
        pageSize: typeof pageSize === "number" ? pageSize : 10,
      };
    }
    return undefined;
  }

  /**
   * Returns a new UISettings object with only the pageSize updated for the given table.
   */
  setTablePageSize(
    uiSettings: UISettings,
    tableKey: string,
    pageSize: number
  ): UISettings {
    return {
      ...uiSettings,
      // tables: {
      //   ...uiSettings.tables,
      //   [tableKey]: {
      //     ...uiSettings.tables?.[tableKey],
      //     pageSize,
      //   },
      // },
      [tableKey + "PageSize"]: pageSize,

    };
  }
}